
import { PublicationsOtherByAuthorModel } from '../models/PublicationsOtherByAuthorModel.js';
import { PublicationsOtherByAuthorView } from '../views/PublicationsOtherByAuthorView.js';

export class PublicationsOtherByAuthorController {
    constructor() {

        this.model = new PublicationsOtherByAuthorModel();
        this.view = new PublicationsOtherByAuthorView();

        this.model.subscribe(state => this.view.render(state));
    }
}